export default "__VITE_ASSET__9d10c875__"